module.exports = __webpack_public_path__ + "static/media/ukLaiFang3.895870eb.jpg";